
<template>
  <v-dialog v-model="open" v-show="open" max-width="290">
    <v-card>
        <v-card-title class="fibl-headline">
          {{ $t('firebase.title') }}
        </v-card-title>

        <v-card-text>
          {{this.message}}
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <button  class="register__text" @click.prevent="close">{{ $t('firebase.close') }}</button>
        </v-card-actions>

    </v-card>
  </v-dialog> 
</template>

<script>
import { mapMutations, mapState } from "vuex";

  export default {

    name: 'MessageModal',

    computed: {
      ...mapState(['project','message','locale','showModal']),

      nameProperty: function () {
        return 'name_'+this.locale
      },

     open: function() {
        return this.$store.state.showModal;
     }
    },

    data() {
      return {
        
      };
    },

    methods: {
      ...mapMutations(['toggleModal']),
      close() {
        this.toggleModal();
      },    
    },

  };
</script>